import React from "react";
import Places from "../pages/places/Places";
import Entrevista from "../pages/entrevista/Entrevista";
import Entrevistas from "../pages/entrevistas/Entrevistas";
import Cadastros from "../pages/cadastros/Cadastros";
import CadastrosLocal from "../pages/cadastros/CadastrosLocal";
import FacilitadorHome from "../pages/facilitadorHome/FacilitadorHome";
import Home from "../pages/home/Home";
import ListaEntrevistadores from "../pages/listaEntrevistadores/ListaEntrevistadores";
import MeusHorarios from "../pages/meusHorarios/MeusHorarios";
import Ocorrencia from "../pages/ocorrencia/Ocorrencia";
import PlantaoDigital from "../pages/plantaoDigital/PlantaoDigital";
import Plantoes from "../pages/plantoes/Plantoes";
import PlantoesCadastrados from "../pages/plantoesCadastrados/PlantoesCadastrados";
import UserHome from "../pages/userHome/UserHome";
import Login from "../pages/login/Login";
import Configuration from "../pages/configuration/configuration";
import UpdateContactInfo from "../pages/updateContactInfo/UpdateContactInfo";
import { USER_ROLE, UserRole } from "../types/roles";
import Plantao from "../pages/plantao/Plantao";

export type RouteConfig = {
  path: string;
  element: React.ReactNode;
  isProtected?: boolean; // Se true (padrão), rota é protegida
  allowedRoles?: UserRole[]; // Se definido, apenas usuários com estes roles podem acessar
  skipContactInfoGate?: boolean;
};

export const routes: RouteConfig[] = [
  { path: "/", element: <UserHome />, isProtected: true },
  { path: "/cidades", element: <Places />, isProtected: true },
  { path: "/entrevista", element: <Entrevista />, isProtected: true },
  { path: "/entrevistas", element: <Entrevistas />, isProtected: true },
  {
    path: "/facilitador-home",
    element: <FacilitadorHome />,
    isProtected: true,
    allowedRoles: [USER_ROLE.facilitador, USER_ROLE.administrator]
  },
  { path: "/meus-horarios", element: <MeusHorarios />, isProtected: true },
  {
    path: "/admin-entrevistadores",
    element: <ListaEntrevistadores />,
    isProtected: true,
    allowedRoles: [USER_ROLE.administrator]
  },
  {
    path: "/ocorrencia",
    element: <Ocorrencia />,
    isProtected: true,
    allowedRoles: [
      USER_ROLE.entrevistador,
      USER_ROLE.facilitador,
      USER_ROLE.administrator
    ]
  },
  { path: "/plantao-digital", element: <PlantaoDigital />, isProtected: true },
  {
    path: "/plantoes",
    element: <Plantoes />,
    isProtected: true
  },
  { path: "/user-home", element: <UserHome />, isProtected: true },
  {
    path: "/update-contact-info",
    element: <UpdateContactInfo />,
    isProtected: true,
    skipContactInfoGate: true
  },
  {
    path: "/cadastros",
    element: <Cadastros />,
    isProtected: true,
    allowedRoles: [USER_ROLE.facilitador, USER_ROLE.administrator]
  },
  {
    path: "/cadastros/local",
    element: <CadastrosLocal />,
    isProtected: true,
    allowedRoles: [USER_ROLE.facilitador, USER_ROLE.administrator]
  },
  { path: "/plantoes-cadastrados", element: <PlantoesCadastrados />, isProtected: true },
  { path: "/escolha-tipo-inscricao", element: <Home />, isProtected: true },
  {
    path: "/plantao",
    element: <Plantao />,
    isProtected: true,
    allowedRoles: [USER_ROLE.facilitador, USER_ROLE.administrator]
  },
  {
    path: "/plantao/:id",
    element: <Plantao />,
    isProtected: true,
    allowedRoles: [USER_ROLE.facilitador, USER_ROLE.administrator]
  },
  { path: "/login", element: <Login />, isProtected: false },
  { path: "/config", element: <Configuration />, isProtected: false }
];
